import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["align", "animate", "children", "onOpenStart", "onOpenComplete", "onCloseStart", "onCloseComplete", "open", "panelKey", "rootNode"];
let _ = t => t,
  _t;
import { Component, Fragment } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { OLAF } from 'HubStyleTokens/colors';
import { URANUS_LAYER } from 'HubStyleTokens/sizes';
// @ts-expect-error untyped module
import ShareScrollElement from 'UIComponents/decorators/ShareScrollElement';
import MobilePanelTransition from './internal/MobilePanelTransition';
import MobileLayer from './MobileLayer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MobilePanelGlobalStyle = createGlobalStyle(_t || (_t = _`
  #hubspot-messages-iframe-container {
    z-index: 0 !important;
  }
  body {
    top: ${0};
  }
`), `-${window.scrollY}px`);
const StyledPanelWrapper = styled.div.withConfig({
  displayName: "MobilePanel__StyledPanelWrapper",
  componentId: "sc-1mgom4b-0"
})(["&&{display:flex;flex-direction:row;background:", ";height:100%;min-width:100%;width:100%;overflow-x:hidden;overflow-y:auto;z-index:", ";}"], OLAF, URANUS_LAYER);
const StyledPanelInner = styled.div.withConfig({
  displayName: "MobilePanel__StyledPanelInner",
  componentId: "sc-1mgom4b-1"
})(["display:flex;flex-direction:column;padding-top:40px;min-height:100%;width:100%;"]);
class MobilePanel extends Component {
  render() {
    const _this$props = this.props,
      {
        align = 'right',
        animate = true,
        children,
        onOpenStart,
        onOpenComplete,
        onCloseStart,
        onCloseComplete,
        open,
        rootNode
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const renderedPanel = /*#__PURE__*/_jsx(StyledPanelWrapper, Object.assign({}, rest, {
      children: /*#__PURE__*/_jsx(StyledPanelInner, {
        children: children
      })
    }));
    return open ? /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(MobilePanelGlobalStyle, {}), /*#__PURE__*/_jsx(MobileLayer, {
        "data-layer-for": "Panel",
        offsetTop: "0",
        rootNode: rootNode,
        Transition: MobilePanelTransition,
        transitionProps: {
          onOpenStart,
          onOpenComplete,
          onCloseStart,
          onCloseComplete,
          align,
          duration: animate ? 100 : 0
        },
        children: renderedPanel
      })]
    }) : null;
  }
}
export default ShareScrollElement(MobilePanel);